import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import { AxiosInstance, AxiosPromise } from 'axios';
import {
  TerminalContactBulkDeleteRequest,
  TerminalContactBulkDeleteResponse,
} from './TerminalContactBulkService.types';

export class TerminalContactBulkService implements BaseRequestEndpoints {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  create(_request: unknown): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  getById(_request: unknown): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  search(_request: unknown): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  update(_request: unknown): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  delete(request: TerminalContactBulkDeleteRequest) {
    return this.instance.delete<TerminalContactBulkDeleteResponse>(
      `/terminals/${request.routeParams.terminalGuid}/contacts`,
      {
        data: request.body,
      },
    );
  }
}
